import {
  type QuizQuestionPoints,
  type QuizQuestionPointsOption,
} from '@efdigital/ll-addon-data';
import { DataTypeQuiz } from '@efdigital/ll-addon-data/data-types';
import { generateRandomSlug } from '@efdigital/ll-admin-v2/lib/random-slug.ts';
import { type OptionWithValue } from '@efdigital/ll-admin-v2/utils/quiz-choices';
import { uniqueId } from '@ember/helper';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import { Type } from '@warp-drive/core/types/symbols';

import { type QuizQuestionEditorComponentSignature } from '../../types/question-manager.ts';
import { EditOptions } from './shared/edit-options.gts';
import RequiredCheckbox from './shared/required-checkbox.gts';

export class PointsQuestionEditorComponent extends Component<QuizQuestionEditorComponentSignature> {
  get questionData(): QuizQuestionPoints {
    return this.args.question.points!;
  }

  updateOptions = (options: QuizQuestionPointsOption[]) => {
    this.questionData.options = options;
  };

  addOption = (option?: OptionWithValue) => {
    this.questionData.options.push({
      [Type]: DataTypeQuiz.QuizQuestionPointsOption,
      oid: generateRandomSlug(),
      value: option?.value ?? '',
      category: '',
    });
  };

  updateOption = (option: QuizQuestionPointsOption, event: Event) => {
    option.value = (event.target as HTMLInputElement).value;
  };

  removeOptionAt = (index: number) => {
    this.questionData.options.splice(index, 1);
  };

  setMin = (event: Event) => {
    this.questionData.min =
      parseInt((event.target as HTMLInputElement).value) || 0;
  };

  setMax = (event: Event) => {
    this.questionData.max =
      parseInt((event.target as HTMLInputElement).value) || 0;
  };

  setPresets = (options: OptionWithValue[]) => {
    for (const option of options) {
      this.addOption(option);
    }
  };

  <template>
    {{#let (uniqueId) as |uniqueId|}}
      <div class="card-body">
        <RequiredCheckbox @question={{@question}} />

        <div class="form-group mb-3">
          <div class="form-label">Points</div>
          <div class="form-text">The user can assign a number of points to each
            option. You can set a minimum and maximum number of points that can
            be assigned.</div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group mb-4">
              <label class="form-label" for="{{uniqueId}}-min">Minimum</label>
              <input
                type="number"
                class="form-control"
                id="{{uniqueId}}-min"
                value={{this.questionData.min}}
                {{on "change" this.setMin}}
              />
            </div>

          </div>
          <div class="col-md-6">

            <div class="form-group mb-4">
              <label class="form-label" for="{{uniqueId}}-max">Maximum</label>
              <input
                type="number"
                class="form-control"
                id="{{uniqueId}}-max"
                value={{this.questionData.max}}
                {{on "change" this.setMax}}
              />
            </div>
          </div>
        </div>

        <EditOptions
          @uniqueId={{uniqueId}}
          @options={{this.questionData.options}}
          @updateOptions={{this.updateOptions}}
          @updateOption={{this.updateOption}}
          @removeOptionAt={{this.removeOptionAt}}
          @addOption={{this.addOption}}
          @setPresets={{this.setPresets}}
        />
      </div>
    {{/let}}
  </template>
}
